import {all, call, put, takeLatest} from 'redux-saga/effects';
import userActions from '../actions/user.actions';
import influencerActions from '../actions/influencer.actions';
import InfluencerApi from '../api/InfluencerApi';
import errorActions from '../actions/error.actions';

function* createInfluencerProfile(action) {
    try {
        const result = yield call(InfluencerApi.createInfluencerProfile, action.payload);
        yield put(influencerActions.createInfluencerProfileSuccess(result));
    } catch (e) {
        const returnedEvents = [put(influencerActions.createInfluencerProfileFailed(e))];

        if (e && e.response && e.response.status === 401) {
            returnedEvents.push(put(userActions.logoutEvent()));
        }

        yield all(returnedEvents);
    }
}

function* resendEmailVerification() {
    try {
        const result = yield call(InfluencerApi.resendEmailVerification, {});
        if (result.status === 'Error') {
            yield put(errorActions.showErrorMessage(result));
            yield put(influencerActions.resendEmailVerificationFailed());
            return;
        }
        yield put(influencerActions.resendEmailVerificationSuccess(result));
    } catch (e) {
        yield put(influencerActions.resendEmailVerificationFailed(e));
    }
}

function* getAccountSocialLinks() {
    try {
        const result = yield call(InfluencerApi.getAccountSocialLinks, {});
        if (result.status === 'Error') {
            yield put(errorActions.showErrorMessage(result));
            yield put(influencerActions.getSocialLinksFailed());
            return;
        }
        yield put(influencerActions.getSocialLinksSuccess(result.data));
    } catch (e) {
        yield put(influencerActions.getSocialLinksFailed(e));
    }
}

function* influencerSaga() {
    yield takeLatest(influencerActions.TYPES.CREATE_INFLUENCER_PROFILE, createInfluencerProfile);
    yield takeLatest(influencerActions.TYPES.RESEND_EMAIL_VERIFICATION, resendEmailVerification);
    yield takeLatest(influencerActions.TYPES.GET_ACCOUNT_SOCIAL_LINKS, getAccountSocialLinks);
}

export default influencerSaga;
